import { css } from 'styled-components';

import { OptionsContainerAlign } from '..';

export function getAlign(align?: OptionsContainerAlign) {
  switch (align) {
    case 'left':
      return css`
        left: 0;
        transform: translate3d(0, 100%, 0);
      `;
    case 'center':
      return css`
        left: 50%;
        transform: translate3d(-50%, 100%, 0);
      `;
    default:
      return css`
        right: 0;
        transform: translate3d(0, 100%, 0);
      `;
  }
}
